import { useState } from "react";

const INTRO_KEY = "kayros.dynamic-documents.editor.intro";
const INTRO_SEEN = "seen";

const introSeen = () => {
  try {
    return window.localStorage.getItem(INTRO_KEY) === INTRO_SEEN;
  } catch (_error) {
    return false;
  }
};

const rememberIntro = () => {
  try {
    window.localStorage.setItem(INTRO_KEY, INTRO_SEEN);
    return true;
  } catch (_error) {
    return false;
  }
};

const useEditorIntro = () => {
  const [shown, setShown] = useState(() => !introSeen());

  const dismiss = () => {
    if (!shown) return;
    setShown(false);
    rememberIntro();
  };

  return { shown, dismiss };
};

export default useEditorIntro;
